import {createAction, props} from '@ngrx/store';

export enum HistoriaNawigacjiActionTypes {
  AKTUALIZUJ_HISTORIE_NAWIGACJI = '[Historia Nawigacji] aktualizuj',
}

export const aktualizujHistorieNawigacji = createAction(
  HistoriaNawigacjiActionTypes.AKTUALIZUJ_HISTORIE_NAWIGACJI,
  props<{ historia: string[] }>()
);
